import React from 'react';
import { createRoot } from 'react-dom/client';
import HubPage from '../HubPage';

const root = createRoot(document.getElementById('root'));
root.render(<HubPage />);
